'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import PaginationProvider from './pagination-provider';
import ParamsProvider from './params-provider';
export const DEFAULT_PAGE_SIZE = 10;
export const PaginationProviderV2 = ({ children, defaultPageSize = DEFAULT_PAGE_SIZE, defaultPage = 1, }) => {
    return (_jsx(ParamsProvider, { children: _jsx(PaginationProvider, { defaultPage: defaultPage, defaultPageSize: defaultPageSize, children: children }) }));
};
export { usePagination } from './pagination-provider';
export { ParamsProvider, useParams } from './params-provider';
export default PaginationProviderV2;
